import * as helper from "../utils/helper";

function SubmitAnswer(props:any) {
  const { user, question, submit } = props;
  return (
    <div className="row justify-content-center">
      <div className="container card1 col-5">
        <div className="row col-12 title_bg">{user.name}</div>
        <p className="dateFormat">{helper.formatDate(question.timestamp)}</p>
        <div className="row">
          <div className="avatar col-4">
            <img className="image" src={user.avatarURL} alt="avatar" />
          </div>
          <div className="col-8">
            <p className="title">Would You Rather</p>
            <input
              className="form-check-input"
              type="radio"
              id="optionOne"
              name="question"
              value="optionOne"
            />
            <label htmlFor="optionOne" className="form-check-label">
              {question.optionTwo.text}
            </label>
            <br />
            <input
              className="form-check-input"
              type="radio"
              id="optionTwo"
              name="question"
              value="optionTwo"
            />
            <label htmlFor="optionTwo" className="form-check-label">
              {question.optionOne.text}
            </label>
          </div>
        </div>
        <div className="row viewBtn">
          <div className="col-3"></div>
          <button onClick={submit} className="btn alert-success btn-sm col-6">
            Submit
          </button>
          <div className="col-3"></div>
        </div>
      </div>
    </div>
  );
}

export default SubmitAnswer;
